import { useState, useRef, useEffect } from "react"

const useYoutubeModalLogic = initialVideoId => {
  const [player, setPlayer] = useState(null)
  const playerRef = useRef()
  const [showYoutubeModal, setShowYoutubeModal] = useState(false)
  const [autoplay, setAutoplay] = useState(1)
  const [videoId, setVideoId] = useState(initialVideoId)

  const loadIframePlayerAPI = () => {
    const tag = document.createElement("script")
    tag.src = "https://www.youtube.com/iframe_api"
    const firstScriptTag = document.getElementsByTagName("script")[0]
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
  }

  useEffect(() => {
    if (showYoutubeModal) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = "auto"
    }

    return () => {
      document.body.style.overflow = "auto"
    }
  }, [showYoutubeModal])

  const onYouTubeIframeAPIReady = () => {
    if (player) {
      player.destroy()
      setPlayer(null)
    }

    const newPlayer = new window.YT.Player(playerRef.current, {
      videoId: videoId,
      playerVars: {
        autoplay: autoplay,
        controls: 1,
      },
      events: {
        onStateChange: onPlayerStateChange,
      },
    })

    setPlayer(newPlayer)
  }

  const onPlayerStateChange = event => {
    if (event.data === window.YT.PlayerState.ENDED) {
      hideYoutubeModal()
    }
  }

  const openYoutubeModal = newVideoId => {
    setAutoplay(1)
    if (newVideoId) {
      setVideoId(newVideoId)
    }
    setShowYoutubeModal(true)
  }

  const hideYoutubeModal = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen()
    }
    if (player) {
      player.destroy()
    }
    setShowYoutubeModal(false)
  }

  useEffect(() => {
    loadIframePlayerAPI()
  }, [])

  useEffect(() => {
    if (showYoutubeModal && playerRef.current) {
      onYouTubeIframeAPIReady()
    }
  }, [showYoutubeModal, videoId])

  return {
    showYoutubeModal,
    openYoutubeModal,
    hideYoutubeModal,
    playerRef,
  }
}

export default useYoutubeModalLogic
